export const PKG_NAME = "@hpcc-js/comms";
export const PKG_VERSION = "2.99.1";
export const BUILD_VERSION = "2.107.3";
